import { API } from '../../../API'
import { boot } from '../../../boot'
import { BootOpt, System } from '../../../system'
import { Unlisten } from '../../../types/Unlisten'
import { SYSTEM_ROOT_ID } from '../../constants/SYSTEM_ROOT_ID'
import { attachApp } from '../../render/attachApp'
import { attachGesture } from '../../render/attachGesture'
import { attachHTML } from '../../render/attachHTML'
import { attachLayout } from '../../render/attachLayout'
import { attachLongPress } from '../../render/attachLongPress'
import { attachStyle } from '../../render/attachStyle'
import { attachSVG } from '../../render/attachSVG'
import { attachVoid } from '../../render/attachVoid'
import { webAlert } from './api/alert'
import { webAnimation } from './api/animation'
import { webBluetooth } from './api/bluetooth'
import { webClipboard } from './api/clipboard'
import { webCrypto } from './api/crypto'
import { webDB } from './api/db'
import { webDevice } from './api/device'
import { webDocument } from './api/document'
import { webFile } from './api/file'
import { webGeolocation } from './api/geolocation'
import { webHistory } from './api/history'
import { webHTTP } from './api/http'
import { webInput } from './api/input'
import { webLayout } from './api/layout'
import { webLocation } from './api/location'
import { webMedia } from './api/media'
import { webNavigator } from './api/navigator'
import { webQuerystring } from './api/querystring'
import { webScreen } from './api/screen'
import { webSelection } from './api/selection'
import { webSpeech } from './api/speech'
import { webText } from './api/text'
import { webTheme } from './api/theme'
import { webURI } from './api/uri'
import { webURL } from './api/url'
import { webWindow } from './api/window'
import { webWorker } from './api/worker'

export function defaultWebBoot(opt?: BootOpt): [System, Unlisten] {
  const root = document.getElementById(SYSTEM_ROOT_ID)

  return webBoot(window, root, opt)
}

export function webBoot(
  window: Window,
  root: HTMLElement,
  opt: BootOpt = {}
): [System, Unlisten] {
  root.attachShadow({ mode: 'open' })

  const http = webHTTP(window, opt)
  const file = webFile(window, opt)
  const screen = webScreen(window, opt)
  const device = webDevice(window, opt)
  const geolocation = webGeolocation(window, opt)
  const speech = webSpeech(window, opt)
  const media = webMedia(window, opt)
  const clipboard = webClipboard(window, opt)
  const selection = webSelection(window, opt)
  const animation = webAnimation(window, opt)
  const document = webDocument(window, root, opt)
  const querystring = webQuerystring(window, opt)
  const bluetooth = webBluetooth(window, opt)
  const text = webText(window, opt)
  const input = webInput(window, root, opt)
  const db = webDB(window, opt)
  const worker = webWorker(window, opt)
  const url = webURL(window, opt)
  const uri = webURI(window, opt)
  const alert = webAlert(window, opt)
  const location = webLocation(window, opt)
  const history = webHistory(window, opt)
  const _window = webWindow(window, opt)
  const navigator = webNavigator(window, opt)
  const layout = webLayout(window, opt)
  const theme = webTheme(window, root, opt)
  const crypto = webCrypto(window, opt)

  const api: API = {
    alert,
    selection,
    file,
    animation,
    db,
    device,
    screen,
    bluetooth,
    clipboard,
    crypto,
    location,
    history,
    geolocation,
    layout,
    media,
    http,
    input,
    speech,
    document,
    querystring,
    text,
    worker,
    url,
    uri,
    window: _window,
    navigator,
    theme,
  }

  const system = boot(null, api, opt)

  system.emitter.addListener('listen', ({ event }: { event: any }) => {
    if (event === 'hashchange') {
      const listener = (event: HashChangeEvent) => {
        const { oldURL, newURL } = event

        system.emitter.emit('hashchange', { oldURL, newURL })
      }

      window.addEventListener('hashchange', listener)

      return () => {
        window.removeEventListener('hashchange', listener)
      }
    }
  })

  root.style.fontFamily = "'Inconsolata', monospace"

  system.root = root

  attachStyle(system)
  attachApp(system)
  attachSVG(system)
  attachHTML(system)
  attachGesture(system)
  attachLongPress(system)
  attachLayout(system)
  attachVoid(system)
  // attachFocus(system)

  const unlisten = () => {}

  return [system, unlisten]
}
